/**
 * Route prefetch map — maps path prefixes to their lazy-loaded chunk loaders.
 * When a user hovers a sidebar link, we trigger the import() to start
 * downloading the chunk before they click.
 *
 * Each loader is only called once — subsequent calls return the cached promise.
 */

const prefetchCache = new Set<string>();

// Platform routes are eagerly imported (not code-split), so there is nothing to
// prefetch, and the monolith's tenant-module route loaders do not exist in the
// platform app. Empty map → prefetchRoute() is a safe no-op here.
const routeLoaders: Record<string, () => Promise<unknown>> = {};

/**
 * Call this on mouseEnter / focus of a navigation link.
 * Finds the best-matching route loader and triggers the chunk download.
 */
export function prefetchRoute(path: string) {
  if (prefetchCache.has(path)) return;

  // Find the longest matching prefix
  const match = Object.keys(routeLoaders)
    .filter((prefix) => path.startsWith(prefix))
    .sort((a, b) => b.length - a.length)[0];

  if (match) {
    prefetchCache.add(path);
    routeLoaders[match]();
  }
}
